import React from 'react'
// import config from '../../config'
import format from '../../helpers/format'
// import { Link, LinkIcon } from '../'

const EsgConfig = {
  esgNamesLabels: [
    {
      label: 'Overall gender equality score',
      value: 'gef_score_norm',
    },
    {
      label: 'Gender balance in leadership and workforce',
      value: 'gef_score_a',
    },
    {
      label: 'Equal compensation and work life balance',
      value: 'gef_score_b',
    },
    {
      label: 'Policies promoting gender equality',
      value: 'gef_score_c',
    },
    {
      label: 'Commitment, transparency, and accountability',
      value: 'gef_score_d',
    },
  ],
  esgOptions: {
    gef_score_norm: {
      id: 'gef_score_norm',
      icon: 'icons_step2',
      fieldLabel: 'gef_score_norm',
      benchLabel: 'gef_score_norm',
      valueLabel: 'Overall gender equality score',
      direction: 'descending',
      page: 'gender-equality-score',
      label: 'overall gender equality score',
      units: (diff) => ' / 100 points',
      unitsExpanded: (diff) => ' / 100 points',
      diffGood: (diff) => (diff > 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-good' : 'lower-bad',
      moreLess: (diff) => (diff > 0) ? 'Higher' : 'Lower',
      format : (val) => format.number(val),
      formatExpanded: (val, moreLess, postiveNegative, url) => {
        if (format.roundsToZero(val)) {
          return (
            <span>
              <strong>the same </strong> gender equality overall score
            </span>
          )
        }
        return (
          <span>
            an overall gender equality score <strong styleName={postiveNegative}>{moreLess} by {format.number(val)} {format.maybePluralize(format.number(val), 'point')} out of 100</strong>
          </span>
        )
      }
    },
    gef_score_a: {
      id: 'gef_score_a',
      icon: 'icons_step3',
      fieldLabel: 'gef_score_a',
      benchLabel: 'gef_score_a',
      valueLabel: 'Gender balance in leadership and workforce',
      direction: 'descending',
      page: 'gender-equality-subscore-a',
      label: 'gender balance in leadership and workforce score',
      units: (diff) => ' / 40 points',
      unitsExpanded: (diff) => ' / 40 points',
      diffGood: (diff) => (diff > 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-good' : 'lower-bad',
      moreLess: (diff) => (diff > 0) ? 'Higher' : 'Lower',
      format : (val) => format.number(val),
      formatExpanded: (val, moreLess, postiveNegative, url) => {
        if (format.roundsToZero(val)) {
          return (
            <span>
              <strong>the same </strong> subscoreA score
            </span>
          )
        }
        return (
          <span>
            a subscoreA score <strong styleName={postiveNegative}>{moreLess} by {format.number(val)} {format.maybePluralize(format.number(val), 'point')} out of 40</strong>
          </span>
        )
      }
    },
    gef_score_b: {
      id: 'gef_score_b',
      icon: 'icons_step4',
      fieldLabel: 'gef_score_b',
      benchLabel: 'gef_score_b',
      valueLabel: 'Equal compensation and work life balance',
      direction: 'descending',
      page: 'gender-equality-subscore-b',
      label: 'equal compensation and work life balance score',
      units: (diff) => ' / 30 points',
      unitsExpanded: (diff) => ' / 30 points',
      diffGood: (diff) => (diff > 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-good' : 'lower-bad',
      moreLess: (diff) => (diff > 0) ? 'Higher' : 'Lower',
      format : (val) => format.number(val),
      formatExpanded: (val, moreLess, postiveNegative, url) => {
        if (format.roundsToZero(val)) {
          return (
            <span>
              <strong>the same </strong> subscoreB score
            </span>
          )
        }
        return (
          <span>
            a subscoreB score <strong styleName={postiveNegative}>{moreLess} by {format.number(val)} {format.maybePluralize(format.number(val), 'point')} out of 30</strong>
          </span>
        )
      }
    },
    gef_score_c: {
      id: 'gef_score_c',
      icon: 'icons_step4',
      fieldLabel: 'gef_score_c',
      benchLabel: 'gef_score_c',
      valueLabel: 'Policies promoting gender equality',
      direction: 'descending',
      page: 'gender-equality-subscore-c',
      label: 'policies promoting gender equality score',
      units: (diff) => ' / 20 points',
      unitsExpanded: (diff) => ' / 20 points',
      diffGood: (diff) => (diff > 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-good' : 'lower-bad',
      moreLess: (diff) => (diff > 0) ? 'Higher' : 'Lower',
      format : (val) => format.number(val),
      formatExpanded: (val, moreLess, postiveNegative, url) => {
        if (format.roundsToZero(val)) {
          return (
            <span>
              <strong>the same </strong> subscoreC score
            </span>
          )
        }
        return (
          <span>
            a subscoreC score <strong styleName={postiveNegative}>{moreLess} by {format.number(val)} {format.maybePluralize(format.number(val), 'point')} out of 20</strong>
          </span>
        )
      }
    },
    gef_score_d: {
      id: 'gef_score_d',
      icon: 'icons_step4',
      fieldLabel: 'gef_score_d',
      benchLabel: 'gef_score_d',
      valueLabel: 'Commitment, transparency, and accountability',
      direction: 'descending',
      page: 'gender-equality-subscore-d',
      label: 'commitment, transparency, and accountability score',
      units: (diff) => ' / 10 points',
      unitsExpanded: (diff) => ' / 10 points',
      diffGood: (diff) => (diff > 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-good' : 'lower-bad',
      moreLess: (diff) => (diff > 0) ? 'Higher' : 'Lower',
      format : (val) => format.number(val),
      formatExpanded: (val, moreLess, postiveNegative, url) => {
        if (format.roundsToZero(val)) {
          return (
            <span>
              <strong>the same </strong> subscoreD score
            </span>
          )
        }
        return (
          <span>
            a subscoreD score <strong styleName={postiveNegative}>{moreLess} by {format.number(val)} {format.maybePluralize(format.number(val), 'point')} out of 10</strong>
          </span>
        )
      }
    }
  }
}

export default EsgConfig